import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui-kit/badge';
import { cn } from '@/lib/utils';

/** Marks a settings page that is not built yet. */
export const SoonBadge = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Badge
      variant="outline"
      className={cn(
        'shrink-0 px-1.5 py-0 text-[11px] font-medium text-muted-foreground',
        className
      )}
    >
      {t('SOON')}
    </Badge>
  );
};
